import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';

import { environment } from '../../../environments/environment';
import { UserApiService } from '../../shared/services/api/user-api.service';

const trimmed = (base: string): string => base.replace(/\/+$/, '');
const API_BASES = [trimmed(environment.api), trimmed(environment.streamingApi)];
const PROFILE_URL = `${API_BASES[0]}/user/auth/me`;

const isApiRequest = (url: string): boolean => API_BASES.some((base) => url.startsWith(base + '/'));

/** Any API 403 may mean the cached `/me` keys are stale, so the profile is re-read. */
export const accessDeniedRefreshInterceptor: HttpInterceptorFn = (req, next) => {
  if (!isApiRequest(req.url) || req.url.startsWith(PROFILE_URL)) return next(req);
  const userApi = inject(UserApiService);
  return next(req).pipe(
    catchError((err: unknown) => {
      if (err instanceof HttpErrorResponse && err.status === 403) userApi.noteAccessDenied();
      return throwError(() => err);
    })
  );
};
